import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Radio } from "lucide-react";
import { useAuth, BACKEND_URL } from "../context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const res = await fetch(`${BACKEND_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (res.ok) {
          const data = await res.json();
          localStorage.setItem('token', data.token);
          setUserData(data.user);
          // Clear the hash and navigate
          window.history.replaceState(null, '', '/dashboard');
          navigate('/dashboard', { state: { user: data.user } });
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate, setUserData]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <Radio className="w-12 h-12 text-purple-400 animate-pulse mx-auto mb-4" />
        <p className="text-white">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
